// utils/loveTemplates.js

export const getLoveTemplates = (t) => [
  { id: 'rose',        label: `🌹 ${t('love_card.template_rose')}` },
  { id: 'velours',     label: `💜 ${t('love_card.template_velours')}` },
  { id: 'dore',        label: `✨ ${t('love_card.template_dore')}` },
  { id: 'aquarelle',   label: `🎨 ${t('love_card.template_aquarelle')}` },
  { id: 'nuit',        label: `🌙 ${t('love_card.template_nuit')}` },
  { id: 'algorithmique', label: `💫 ${t('love_card.template_surprise')}` },
];

const seededRandom = (seed) => {
  let s = seed;
  return () => {
    s = (s * 16807 + 0) % 2147483647;
    return (s - 1) / 2147483646;
  };
};

const generateAlgorithmicLoveSVG = (recipientName, message, t) => {
  const seed = Math.floor(Math.random() * 2147483647);
  const rand = seededRandom(seed);

  const palettes = [
    { bg1: '#1a0010', bg2: '#3d0030', accent1: '#ff6b9d', accent2: '#ffd6e7', text: '#fff0f6' },
    { bg1: '#2d0a1e', bg2: '#5c1a3e', accent1: '#ff4d88', accent2: '#ffb3cc', text: '#ffffff' },
    { bg1: '#0d0020', bg2: '#2d0050', accent1: '#c77dff', accent2: '#ff6b9d', text: '#f8e8ff' },
    { bg1: '#1a0a00', bg2: '#3d1a00', accent1: '#ff9a3c', accent2: '#ff6b9d', text: '#fff0e8' },
    { bg1: '#000d1a', bg2: '#001a33', accent1: '#4fc3f7', accent2: '#f48fb1', text: '#e8f4ff' },
  ];
  const palette = palettes[Math.floor(rand() * palettes.length)];

  // Cœurs de différentes tailles
  const hearts = [];
  for (let i = 0; i < 20; i++) {
    const x = rand() * 600;
    const y = rand() * 400;
    const size = 6 + rand() * 20;
    const opacity = 0.2 + rand() * 0.5;
    const color = rand() > 0.5 ? palette.accent1 : palette.accent2;
    const scale = size / 20;
    hearts.push(`
      <g transform="translate(${x.toFixed(1)}, ${y.toFixed(1)}) scale(${scale.toFixed(2)})" opacity="${opacity.toFixed(2)}">
        <path d="M 0,-8 C 0,-14 -10,-14 -10,-8 C -10,-2 0,6 0,10 C 0,6 10,-2 10,-8 C 10,-14 0,-14 0,-8 Z" fill="${color}"/>
      </g>`);
  }

  // Étoiles scintillantes
  const stars = [];
  for (let i = 0; i < 15; i++) {
    const x = rand() * 600;
    const y = rand() * 400;
    const r = 2 + rand() * 5;
    const color = rand() > 0.5 ? palette.accent1 : palette.accent2;
    stars.push(`<circle cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="${r.toFixed(1)}" fill="${color}" opacity="${(0.3 + rand() * 0.6).toFixed(2)}"/>`);
  }

  // Lignes courbes romantiques
  const curves = [];
  for (let i = 0; i < 6; i++) {
    const x1 = rand() * 600;
    const y1 = rand() * 400;
    const cx = rand() * 600;
    const cy = rand() * 400;
    const x2 = rand() * 600;
    const y2 = rand() * 400;
    const color = rand() > 0.5 ? palette.accent1 : palette.accent2;
    curves.push(`<path d="M ${x1.toFixed(0)} ${y1.toFixed(0)} Q ${cx.toFixed(0)} ${cy.toFixed(0)} ${x2.toFixed(0)} ${y2.toFixed(0)}" stroke="${color}" stroke-width="${(0.5 + rand()).toFixed(1)}" fill="none" opacity="${(0.15 + rand() * 0.25).toFixed(2)}"/>`);
  }

  const msg = message || `${t('love_card.i_love_you')} ${recipientName}`;
// 🧠 wrap texte
  const wrapText = (text, maxChars = 50) => {
    const words = text.split(' ');
    const lines = [];
    let line = '';

    words.forEach(word => {
      const testLine = line ? `${line} ${word}` : word;
      if (testLine.length > maxChars) {
        lines.push(line);
        line = word;
      } else {
        line = testLine;
      }
    });

    if (line) lines.push(line);
    return lines;
  };

  const messageLines = wrapText(msg, 70);

  return `
<svg viewBox="0 0 600 400" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="bgLove" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" style="stop-color:${palette.bg1}"/>
      <stop offset="100%" style="stop-color:${palette.bg2}"/>
    </linearGradient>
    <linearGradient id="textLoveGrad" x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="0%" style="stop-color:${palette.accent1}"/>
      <stop offset="100%" style="stop-color:${palette.accent2}"/>
    </linearGradient>
  </defs>
  <rect width="600" height="400" fill="url(#bgLove)"/>
  ${curves.join('\n  ')}
  ${stars.join('\n  ')}
  ${hearts.join('\n  ')}
  <rect x="0" y="145" width="600" height="120" fill="rgba(0,0,0,0.4)" rx="0"/>
  <text x="300" y="185" text-anchor="middle" font-family="Georgia, serif" font-size="16" fill="${palette.accent1}" letter-spacing="5" opacity="0.9">
    ♥ ${t('love_card.title_upper')} ♥
  </text>
  <text x="300" y="228" text-anchor="middle" font-family="Georgia, serif" font-size="40" font-weight="bold" fill="url(#textLoveGrad)">
    ${recipientName}
  </text>
  <text x="300" y="310" text-anchor="middle" font-family="Georgia, serif" font-size="16" fill="${palette.text}" font-style="italic" opacity="0.9">
    ${messageLines.map((line, i) => `
      <tspan x="300" dy="${i === 0 ? 0 : 28}">
        ${line}
      </tspan>
    `).join('')}

  </text>
</svg>`;
};

export const generateLoveSVG = (templateId, recipientName, message, t) => {
  const msg = message || `${t('love_card.i_love_you')} ${recipientName}`;
// 🧠 wrap texte
  const wrapText = (text, maxChars = 50) => {
    const words = text.split(' ');
    const lines = [];
    let line = '';

    words.forEach(word => {
      const testLine = line ? `${line} ${word}` : word;
      if (testLine.length > maxChars) {
        lines.push(line);
        line = word;
      } else {
        line = testLine;
      }
    });

    if (line) lines.push(line);
    return lines;
  };

  const messageLines = wrapText(msg, 70);

  if (templateId === 'algorithmique') {
    return generateAlgorithmicLoveSVG(recipientName, message, t);
  }

  const templates = {

    rose: `
<svg viewBox="0 0 600 400" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="bgRose" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" style="stop-color:#ff0844"/>
      <stop offset="100%" style="stop-color:#ffb199"/>
    </linearGradient>
  </defs>
  <rect width="600" height="400" fill="url(#bgRose)"/>
  <!-- Pétales de rose décoratives -->
  <ellipse cx="60" cy="60" rx="40" ry="20" fill="#ff6b9d" opacity="0.4" transform="rotate(-30 60 60)"/>
  <ellipse cx="540" cy="60" rx="40" ry="20" fill="#ff6b9d" opacity="0.4" transform="rotate(30 540 60)"/>
  <ellipse cx="60" cy="340" rx="40" ry="20" fill="#ff6b9d" opacity="0.4" transform="rotate(30 60 340)"/>
  <ellipse cx="540" cy="340" rx="40" ry="20" fill="#ff6b9d" opacity="0.4" transform="rotate(-30 540 340)"/>
  <!-- Cœurs -->
  <g transform="translate(80,200) scale(1.5)" opacity="0.3">
    <path d="M 0,-8 C 0,-14 -10,-14 -10,-8 C -10,-2 0,6 0,10 C 0,6 10,-2 10,-8 C 10,-14 0,-14 0,-8 Z" fill="white"/>
  </g>
  <g transform="translate(520,200) scale(1.5)" opacity="0.3">
    <path d="M 0,-8 C 0,-14 -10,-14 -10,-8 C -10,-2 0,6 0,10 C 0,6 10,-2 10,-8 C 10,-14 0,-14 0,-8 Z" fill="white"/>
  </g>
  <g transform="translate(300,80) scale(2.5)" opacity="0.25">
    <path d="M 0,-8 C 0,-14 -10,-14 -10,-8 C -10,-2 0,6 0,10 C 0,6 10,-2 10,-8 C 10,-14 0,-14 0,-8 Z" fill="white"/>
  </g>
  <!-- Bordure -->
  <rect x="15" y="15" width="570" height="370" fill="none" stroke="rgba(255,255,255,0.4)" stroke-width="1.5" rx="8"/>
  <!-- Texte -->
  <text x="300" y="155" text-anchor="middle" font-family="Georgia, serif" font-size="18" fill="white" letter-spacing="4" opacity="0.9">♥ ${t('love_card.title_upper')} ♥</text>
  <text x="300" y="210" text-anchor="middle" font-family="Georgia, serif" font-size="44" font-weight="bold" fill="white">${recipientName}</text>
  <text x="300" y="265" text-anchor="middle" font-family="Georgia, serif" font-size="17" fill="white" font-style="italic" opacity="0.9">${messageLines.map((line, i) => `
      <tspan x="300" dy="${i === 0 ? 0 : 28}">
        ${line}
      </tspan>
    `).join('')}
</text>
  <!-- Petits cœurs bas -->
  <text x="250" y="330" font-size="18" fill="white" opacity="0.6">♥</text>
  <text x="290" y="345" font-size="12" fill="white" opacity="0.4">♥</text>
  <text x="320" y="330" font-size="22" fill="white" opacity="0.6">♥</text>
  <text x="355" y="342" font-size="14" fill="white" opacity="0.4">♥</text>
</svg>`,

    velours: `
<svg viewBox="0 0 600 400" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="bgVelours" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" style="stop-color:#4a0030"/>
      <stop offset="100%" style="stop-color:#1a0010"/>
    </linearGradient>
    <linearGradient id="accentVelours" x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="0%" style="stop-color:#ff6b9d"/>
      <stop offset="100%" style="stop-color:#c77dff"/>
    </linearGradient>
  </defs>
  <rect width="600" height="400" fill="url(#bgVelours)"/>
  <!-- Bordure dorée -->
  <rect x="12" y="12" width="576" height="376" fill="none" stroke="url(#accentVelours)" stroke-width="1.5" rx="6"/>
  <rect x="20" y="20" width="560" height="360" fill="none" stroke="url(#accentVelours)" stroke-width="0.5" rx="4" opacity="0.5"/>
  <!-- Ornements coins -->
  <circle cx="12" cy="12" r="4" fill="#ff6b9d"/>
  <circle cx="588" cy="12" r="4" fill="#ff6b9d"/>
  <circle cx="12" cy="388" r="4" fill="#ff6b9d"/>
  <circle cx="588" cy="388" r="4" fill="#ff6b9d"/>
  <!-- Grand cœur central décoratif -->
  <g transform="translate(300,80) scale(3)" opacity="0.15">
    <path d="M 0,-8 C 0,-14 -10,-14 -10,-8 C -10,-2 0,6 0,10 C 0,6 10,-2 10,-8 C 10,-14 0,-14 0,-8 Z" fill="#ff6b9d"/>
  </g>
  <!-- Petits cœurs coins -->
  <g transform="translate(50,50) scale(1.2)" opacity="0.4">
    <path d="M 0,-8 C 0,-14 -10,-14 -10,-8 C -10,-2 0,6 0,10 C 0,6 10,-2 10,-8 C 10,-14 0,-14 0,-8 Z" fill="#ff6b9d"/>
  </g>
  <g transform="translate(550,50) scale(1.2)" opacity="0.4">
    <path d="M 0,-8 C 0,-14 -10,-14 -10,-8 C -10,-2 0,6 0,10 C 0,6 10,-2 10,-8 C 10,-14 0,-14 0,-8 Z" fill="#c77dff"/>
  </g>
  <g transform="translate(50,350) scale(1.2)" opacity="0.4">
    <path d="M 0,-8 C 0,-14 -10,-14 -10,-8 C -10,-2 0,6 0,10 C 0,6 10,-2 10,-8 C 10,-14 0,-14 0,-8 Z" fill="#c77dff"/>
  </g>
  <g transform="translate(550,350) scale(1.2)" opacity="0.4">
    <path d="M 0,-8 C 0,-14 -10,-14 -10,-8 C -10,-2 0,6 0,10 C 0,6 10,-2 10,-8 C 10,-14 0,-14 0,-8 Z" fill="#ff6b9d"/>
  </g>
  <!-- Texte -->
  <text x="300" y="165" text-anchor="middle" font-family="Georgia, serif" font-size="14" fill="#ff6b9d" letter-spacing="6" opacity="0.9">♥ ${t('love_card.title_upper')} ♥</text>
  <text x="300" y="215" text-anchor="middle" font-family="Georgia, serif" font-size="44" font-weight="bold" fill="url(#accentVelours)">${recipientName}</text>
  <text x="300" y="270" text-anchor="middle" font-family="Georgia, serif" font-size="16" fill="#ffd6e7" font-style="italic" opacity="0.9">${messageLines.map((line, i) => `
      <tspan x="300" dy="${i === 0 ? 0 : 28}">
        ${line}
      </tspan>
    `).join('')}
</text>
  <!-- Ligne décorative -->
  <line x1="150" y1="240" x2="220" y2="240" stroke="url(#accentVelours)" stroke-width="0.8" opacity="0.5"/>
  <line x1="380" y1="240" x2="450" y2="240" stroke="url(#accentVelours)" stroke-width="0.8" opacity="0.5"/>
</svg>`,

    dore: `
<svg viewBox="0 0 600 400" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="bgDore" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" style="stop-color:#1a0a00"/>
      <stop offset="100%" style="stop-color:#3d1a00"/>
    </linearGradient>
    <linearGradient id="goldLove" x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="0%" style="stop-color:#BF953F"/>
      <stop offset="50%" style="stop-color:#FCF6BA"/>
      <stop offset="100%" style="stop-color:#BF953F"/>
    </linearGradient>
    <linearGradient id="roseGold" x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="0%" style="stop-color:#b76e79"/>
      <stop offset="50%" style="stop-color:#ffd4d8"/>
      <stop offset="100%" style="stop-color:#b76e79"/>
    </linearGradient>
  </defs>
  <rect width="600" height="400" fill="url(#bgDore)"/>
  <!-- Bordures dorées -->
  <rect x="10" y="10" width="580" height="380" fill="none" stroke="url(#goldLove)" stroke-width="2" rx="4"/>
  <rect x="18" y="18" width="564" height="364" fill="none" stroke="url(#roseGold)" stroke-width="0.8" rx="3" opacity="0.6"/>
  <!-- Ornements dorés coins -->
  <circle cx="10" cy="10" r="5" fill="#FCF6BA"/>
  <circle cx="590" cy="10" r="5" fill="#FCF6BA"/>
  <circle cx="10" cy="390" r="5" fill="#FCF6BA"/>
  <circle cx="590" cy="390" r="5" fill="#FCF6BA"/>
  <!-- Cœur doré central -->
  <g transform="translate(300,90) scale(3.5)" opacity="0.2">
    <path d="M 0,-8 C 0,-14 -10,-14 -10,-8 C -10,-2 0,6 0,10 C 0,6 10,-2 10,-8 C 10,-14 0,-14 0,-8 Z" fill="#FCF6BA"/>
  </g>
  <!-- Étoiles dorées -->
  <text x="80" y="100" font-size="16" fill="#FCF6BA" opacity="0.5">✦</text>
  <text x="500" y="100" font-size="16" fill="#FCF6BA" opacity="0.5">✦</text>
  <text x="80" y="320" font-size="16" fill="#FCF6BA" opacity="0.5">✦</text>
  <text x="500" y="320" font-size="16" fill="#FCF6BA" opacity="0.5">✦</text>
  <text x="290" y="50" font-size="12" fill="#FCF6BA" opacity="0.4">✦</text>
  <!-- Texte -->
  <text x="300" y="158" text-anchor="middle" font-family="Georgia, serif" font-size="14" fill="#FCF6BA" letter-spacing="6" opacity="0.8">♥ ${t('love_card.title_upper')} ♥</text>
  <text x="300" y="210" text-anchor="middle" font-family="Georgia, serif" font-size="44" font-weight="bold" fill="url(#goldLove)">${recipientName}</text>
  <text x="300" y="260" text-anchor="middle" font-family="Georgia, serif" font-size="16" fill="url(#roseGold)" font-style="italic" opacity="0.9">${messageLines.map((line, i) => `
      <tspan x="300" dy="${i === 0 ? 0 : 28}">
        ${line}
      </tspan>
    `).join('')}
</text>
  <!-- Ligne dorée -->
  <line x1="120" y1="230" x2="200" y2="230" stroke="url(#goldLove)" stroke-width="0.8"/>
  <line x1="400" y1="230" x2="480" y2="230" stroke="url(#goldLove)" stroke-width="0.8"/>
  <circle cx="300" cy="230" r="3" fill="#FCF6BA" opacity="0.6"/>
</svg>`,

    aquarelle: `
<svg viewBox="0 0 600 400" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="bgAqua" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" style="stop-color:#fff0f5"/>
      <stop offset="100%" style="stop-color:#ffe0ed"/>
    </linearGradient>
    <radialGradient id="tache1" cx="20%" cy="30%">
      <stop offset="0%" style="stop-color:#ff9a9e;stop-opacity:0.4"/>
      <stop offset="100%" style="stop-color:#ff9a9e;stop-opacity:0"/>
    </radialGradient>
    <radialGradient id="tache2" cx="80%" cy="70%">
      <stop offset="0%" style="stop-color:#fad0c4;stop-opacity:0.5"/>
      <stop offset="100%" style="stop-color:#fad0c4;stop-opacity:0"/>
    </radialGradient>
    <radialGradient id="tache3" cx="50%" cy="20%">
      <stop offset="0%" style="stop-color:#f6d365;stop-opacity:0.3"/>
      <stop offset="100%" style="stop-color:#f6d365;stop-opacity:0"/>
    </radialGradient>
  </defs>
  <rect width="600" height="400" fill="url(#bgAqua)"/>
  <!-- Taches aquarelle -->
  <ellipse cx="120" cy="120" rx="150" ry="100" fill="url(#tache1)"/>
  <ellipse cx="480" cy="280" rx="160" ry="110" fill="url(#tache2)"/>
  <ellipse cx="300" cy="80" rx="120" ry="80" fill="url(#tache3)"/>
  <!-- Cœurs aquarelle -->
  <g transform="translate(80,300) scale(2)" opacity="0.2">
    <path d="M 0,-8 C 0,-14 -10,-14 -10,-8 C -10,-2 0,6 0,10 C 0,6 10,-2 10,-8 C 10,-14 0,-14 0,-8 Z" fill="#ff6b9d"/>
  </g>
  <g transform="translate(520,100) scale(1.5)" opacity="0.2">
    <path d="M 0,-8 C 0,-14 -10,-14 -10,-8 C -10,-2 0,6 0,10 C 0,6 10,-2 10,-8 C 10,-14 0,-14 0,-8 Z" fill="#ff6b9d"/>
  </g>
  <!-- Bordure subtile -->
  <rect x="15" y="15" width="570" height="370" fill="none" stroke="#ffb3cc" stroke-width="1" rx="8" opacity="0.6"/>
  <!-- Texte -->
  <text x="300" y="155" text-anchor="middle" font-family="Georgia, serif" font-size="16" fill="#e91e8c" letter-spacing="4" opacity="0.8">♥ ${t('love_card.title_upper')} ♥</text>
  <text x="300" y="210" text-anchor="middle" font-family="Georgia, serif" font-size="44" font-weight="bold" fill="#c2185b">${recipientName}</text>
  <text x="300" y="265" text-anchor="middle" font-family="Georgia, serif" font-size="16" fill="#e91e8c" font-style="italic" opacity="0.9">${messageLines.map((line, i) => `
      <tspan x="300" dy="${i === 0 ? 0 : 28}">
        ${line}
      </tspan>
    `).join('')}
</text>
  <!-- Petits cœurs -->
  <text x="230" y="310" font-size="14" fill="#ff6b9d" opacity="0.5">♥</text>
  <text x="270" y="325" font-size="10" fill="#ff6b9d" opacity="0.3">♥</text>
  <text x="305" y="310" font-size="18" fill="#ff6b9d" opacity="0.5">♥</text>
  <text x="345" y="322" font-size="12" fill="#ff6b9d" opacity="0.3">♥</text>
</svg>`,

    nuit: `
<svg viewBox="0 0 600 400" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="bgNuit" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" style="stop-color:#0a0015"/>
      <stop offset="50%" style="stop-color:#15003a"/>
      <stop offset="100%" style="stop-color:#200040"/>
    </linearGradient>
    <radialGradient id="lune" cx="80%" cy="20%">
      <stop offset="0%" style="stop-color:#fffde7;stop-opacity:0.15"/>
      <stop offset="100%" style="stop-color:#fffde7;stop-opacity:0"/>
    </radialGradient>
  </defs>
  <rect width="600" height="400" fill="url(#bgNuit)"/>
  <!-- Halo lune -->
  <ellipse cx="500" cy="70" rx="120" ry="120" fill="url(#lune)"/>
  <!-- Lune -->
  <circle cx="520" cy="60" r="35" fill="#fffde7" opacity="0.9"/>
  <circle cx="535" cy="50" r="28" fill="#15003a"/>
  <!-- Étoiles -->
  <circle cx="50" cy="40" r="1.5" fill="white" opacity="0.8"/>
  <circle cx="150" cy="20" r="1" fill="white" opacity="0.6"/>
  <circle cx="80" cy="100" r="2" fill="white" opacity="0.7"/>
  <circle cx="200" cy="60" r="1.5" fill="white" opacity="0.5"/>
  <circle cx="30" cy="150" r="1" fill="white" opacity="0.6"/>
  <circle cx="120" cy="180" r="1.5" fill="white" opacity="0.4"/>
  <circle cx="400" cy="30" r="1" fill="white" opacity="0.7"/>
  <circle cx="450" cy="150" r="1.5" fill="white" opacity="0.5"/>
  <circle cx="350" cy="80" r="1" fill="white" opacity="0.6"/>
  <circle cx="250" cy="140" r="2" fill="white" opacity="0.4"/>
  <circle cx="180" cy="300" r="1" fill="white" opacity="0.5"/>
  <circle cx="560" cy="200" r="1.5" fill="white" opacity="0.6"/>
  <circle cx="70" cy="250" r="1" fill="white" opacity="0.4"/>
  <!-- Cœurs lumineux -->
  <g transform="translate(100,320) scale(1.8)" opacity="0.4">
    <path d="M 0,-8 C 0,-14 -10,-14 -10,-8 C -10,-2 0,6 0,10 C 0,6 10,-2 10,-8 C 10,-14 0,-14 0,-8 Z" fill="#ff6b9d"/>
  </g>
  <g transform="translate(500,330) scale(1.3)" opacity="0.3">
    <path d="M 0,-8 C 0,-14 -10,-14 -10,-8 C -10,-2 0,6 0,10 C 0,6 10,-2 10,-8 C 10,-14 0,-14 0,-8 Z" fill="#c77dff"/>
  </g>
  <!-- Grand cœur central -->
  <g transform="translate(300,90) scale(3)" opacity="0.12">
    <path d="M 0,-8 C 0,-14 -10,-14 -10,-8 C -10,-2 0,6 0,10 C 0,6 10,-2 10,-8 C 10,-14 0,-14 0,-8 Z" fill="#ff6b9d"/>
  </g>
  <!-- Texte -->
  <text x="300" y="160" text-anchor="middle" font-family="Georgia, serif" font-size="15" fill="#c77dff" letter-spacing="5" opacity="0.9">♥ ${t('love_card.title_upper')} ♥</text>
  <text x="300" y="215" text-anchor="middle" font-family="Georgia, serif" font-size="44" font-weight="bold" fill="#ff6b9d">${recipientName}</text>
  <text x="300" y="268" text-anchor="middle" font-family="Georgia, serif" font-size="16" fill="#ffd6e7" font-style="italic" opacity="0.9">${messageLines.map((line, i) => `
      <tspan x="300" dy="${i === 0 ? 0 : 28}">
        ${line}
      </tspan>
    `).join('')}
</text>
  <!-- Lucioles -->
  <circle cx="160" cy="240" r="2" fill="#fffde7" opacity="0.6"/>
  <circle cx="440" cy="250" r="1.5" fill="#fffde7" opacity="0.5"/>
  <circle cx="200" cy="350" r="2" fill="#fffde7" opacity="0.4"/>
  <circle cx="400" cy="340" r="1.5" fill="#fffde7" opacity="0.5"/>
</svg>`,

  };

  return templates[templateId] || templates['rose'];
};